<template>
    <div class="failed-test-logs-details">
        <b-progress v-if="loading" type="is-info"/>
        <template v-else-if="testResults">
            <div v-for="(testResult, index) in testResults" :key="testResult.id">
                <h3 class="title is-5">{{ index + 1 }}. {{ testResult.platform }}</h3>
                <p class="subtitle is-5">{{ testResult.result }}</p>
                <b-button tag="a"
                        v-if="testResult.ci_service_url"
                        :href="testResult.ci_service_url"
                        target="_blank"
                        type="is-success"
                        class="ci-service-link-button"
                        outlined>
                          Open CI service
                </b-button>
                <b-button tag="a"
                        v-if="testResult.logs_url"
                        :href="testResult.logs_url"
                        target="_blank"
                        type="is-success"
                        class="ci-service-link-button"
                        outlined>
                          Open logs
                </b-button>
                <div class="test-result-message-container" v-if="testResult.message">
                    <b-button class="copy-message-button"
                              icon-left="content-copy"
                              @click="copyMessage(testResult.message)"
                              rounded
                              size="is-small"
                              type="is-dark"/>
                    <pre class="test-result-message">{{ testResult.message }}</pre>
                </div>
                <hr>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "FailedTestLogsDetails",
    props: {
        testResults: Array,
        loading: Boolean,
    },
    methods: {
        copyMessage(message) {
            this.$copyText(message)
                .then(() => this.$buefy.toast.open('Message was copied'));
        },
    }
}
</script>

<style lang="scss" scoped>
.test-result-message-container {
    position: relative;
}

.copy-message-button {
    position: absolute;
    top: 1em;
    right: 1em;
}

.ci-service-link-button {
    margin-bottom: 1em;
}
</style>
